/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePickDto } from '../../models/create-pick-dto';
import { PickDto } from '../../models/pick-dto';

export interface PickControllerCreate$Params {
      body: CreatePickDto
}

export function pickControllerCreate(http: HttpClient, rootUrl: string, params: PickControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PickDto>> {
  const rb = new RequestBuilder(rootUrl, pickControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PickDto>;
    })
  );
}

pickControllerCreate.PATH = '/api/picks';
